/**
* In this file contains the Diagnosis add popup UI screen and logic
**/
import { Modal,Button } from 'react-bootstrap';
import { useState,useRef } from 'react';
import ApiService from './../../services/ApiService';
import * as Yup from 'yup';
import { validate } from './../../services/ValidationService';
import { toast } from 'react-toastify';
import moment from 'moment'; 
import { flatPickerFormatDate } from './../../services/UtilsService';
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useTranslation } from 'react-i18next';

function DiagnosisAddModal(props) {
	
	/**
	 * Intial state declaration
	 **/
	const [data,setData]=useState({ recorded_date: moment().format('YYYY-MM-DD') });	
	const [error,setError]=useState({});
	const role = Number(localStorage.getItem('role'));
	const recordflatpickrRef = useRef(null); // Create a ref for Flatpickr
	const followflatpickrRef = useRef(null); // Create a ref for Flatpickr
	const { t } = useTranslation();

	/** 
	* Validation schema for Add Diagnosis Fields
	* @diagnosis - required field and pass the diagnosis name
	* @recorded_date - required field and pass the diagnosis recorded_date
	* @notes - required field and pass the notes
	* @treatment - required field and pass the treatment in string
	* @medication - required field and pass the medication details
	* @follow_up - required field and pass the boolean value
	* @follow_up_date - required field when follow_up is true otherwise not required
	**/
   const diagnosisFields = [
    { name: 'diagnosis', validation: Yup.string().trim().required(t('error.required')) },
    { name: 'recorded_date', validation: Yup.string().required(t('error.required')) },
	/*{ name: 'notes', validation: Yup.string().required(t('error.required'))},*/
	{ name: 'treatment', validation: Yup.string().trim().required(t('error.required')) },
	/*{ name: 'medication', validation: Yup.string().required(t('error.required'))},*/
	{ name: 'follow_up', validation: Yup.string().required(t('error.required'))},
	{ name: 'follow_up_date', validation: data.follow_up==="true"?Yup.string().required(t('error.required')):Yup.string()},
   ];
	
	
   /** 
   * To handle input change event 
   * @e - we get the event details from the Change action
   **/
   const handleChange=async(e)=>{
	//    e.preventDefault();
	   const {name,value}=e.target;
	   //console.log(e.target.value);	
	   await setData({...data,[name]:value});
	   const Errors=await validate({[name]:value},diagnosisFields);
	   await setError({...error,[name]:Errors[name]});
   }
   
   /** 
   * To handle radio input change event 
   * @e - we get the event details from the Change action
   **/
    const handleRadioChange = async (e,item) => {
		if(item==="false"){
			data.follow_up_date='';  
		}
	   const {name,value}=e.target;
	   await setData({ ...data, follow_up: item });
	   const Errors=await validate({[name]:value},diagnosisFields);
	   await setError({...error,[name]:Errors[name]});
	};
  
  
   /** 
   * To handle the form submit event 
   * @e - we get the event details from the form submit action
   **/	
  const handleSubmit=async(e)=>{
	  e.preventDefault();
	  const Errors=await validate(data,diagnosisFields)
	  await setError(Errors);
	  
	  if(!Object.keys(Errors).length){
		  data.report_id=props.data.report_id;
		  data.member=props.data.member;
		  if(data.follow_up==="false"){
			data.follow_up_date='';  
		  }
			var response = await ApiService.createDiagnosis(data);
		  if(response.status===200){
				toast.success(response?.data?.message);
				props.handleClose();
		  }else{
			  toast.error(response?.data?.message);
		  }
	  }
  };
	
	
  return (
  <Modal 
	show={props.data.addDiagnosis} 
	onHide={props.handleClose}  
	backdrop="static"
    keyboard={false}
	size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
	enforceFocus={false} // Prevent modal from stealing focus
  >
      <Modal.Header closeButton className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title><h5 className="modal-title" id="AddDiagnosisModal">{t('modal.addDiagnosis')}</h5></Modal.Title>
      </Modal.Header>
      <Modal.Body>
	  {/*DiagnosisAdd Form*/}
	  <form className="form-card " onSubmit={handleSubmit}>
		<div className="row">
			<div className="col-lg-6">
				<div className=" form-group">
					<label>{t('modal.diagnosis')} </label>
					<input type="text" onChange={handleChange} value={data.diagnosis?data.diagnosis:''} name="diagnosis" className="form-control" placeholder={t('common.enterDiagnosis')}/>
					{error && error.diagnosis && <span className="required">{error.diagnosis}</span>}
				</div>
			</div>
			<div className={`col-lg-6 ${
				role === 4  ? 'admin-flatpicker' : 'flatpicker'
			}`}>
				<div className=" form-group">
					<label>{t('modal.recordedDate')} </label>
					{/* <input type="date" onChange={handleChange} value={data.recorded_date?data.recorded_date:''} min={props?.data?.dob} max={new Date().toISOString().split('T')[0]} name="recorded_date" className={`form-control ${role === 4 ? 'admin-date-input' : ''}`} placeholder="Recorded Date "/> */}
					<div className="input-group">
						<Flatpickr
						value={data.recorded_date || ""}
						name="recorded_date"
						onChange={(selectedDates) => {
							const selectedDate = selectedDates[0]; // Get the selected date
							if (selectedDate) {
							// Format the date as 'YYYY-MM-DD'
							const formattedDate = flatPickerFormatDate(selectedDate);
								handleChange({
									target: {
										name: "recorded_date",
										value: formattedDate, // Format as YYYY-MM-DD
									},
								});
							}
						}}
						options={{
							dateFormat: "Y-m-d", // Format of the date
							maxDate: "today", // Minimum date as today
							minDate: props.data?.dob || null, 
							appendTo: document.body, // Ensure dropdown attaches to body
						}}
						placeholder="Choose a date" // Placeholder text
						className="form-control" // Optional: Add a CSS class
						ref={recordflatpickrRef} // Bind Flatpickr to the ref
						/>
						{/* Calendar Icon */}
						<span className="input-group-text input-button" title="toggle"
						onClick={() => recordflatpickrRef.current.flatpickr.open()}>
							<i className="ri-calendar-line"></i>
						</span>
					</div>
					{error && error.recorded_date && <span className="required">{error.recorded_date}</span>}
				</div>
			</div>
			<div className="col-lg-12">
				<div className=" form-group">
					<label>{t('table.notes')} </label>
					<textarea className="form-control" onChange={handleChange} value={data.notes?data.notes:''} name="notes" rows="3"></textarea>
					{error && error.notes && <span className="required">{error.notes}</span>}
				</div>
			</div>
			<div className="col-lg-6">
				<div className=" form-group">
					<label>{t('modal.treatment')} </label>
					<input type="text" onChange={handleChange} value={data.treatment?data.treatment:''} name="treatment" className="form-control" placeholder={t('common.enterTreatment')}/>
					{error && error.treatment && <span className="required">{error.treatment}</span>}
				</div>
			</div>
			{/*<div className="col-lg-6">
				<div className=" form-group">
					<label>{t('table.medication')}</label>
					<input type="text" onChange={handleChange} value={data.medication?data.medication:''} name="medication" className="form-control" placeholder="Enter Medication"/>
					{error && error.medication && <span className="required">{error.medication}</span>}
				</div>
			</div>*/}
			<div className="col-lg-6">
				<div className="form-group">
					<label>{t('modal.needFollowup')}</label>
					<div className="ChecksRadios">
						<div className="form-check form-check-inline">
							<input className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`} type="radio" name="follow_up" onChange={(e)=>handleRadioChange(e,"true")} id="FollowUp1" value="true"/>
						  <label className="form-check-label" htmlFor="FollowUp1"> {t('modal.yes')}</label>
						</div>
						<div className="form-check form-check-inline">
						  <input className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`} type="radio" name="follow_up" onChange={(e)=>handleRadioChange(e,"false")} id="FollowUp2" value="false"/>
						  <label className="form-check-label" htmlFor="FollowUp2"> {t('modal.no')}</label>
						</div>
					</div>
					{error && error.follow_up && <span className="required">{error.follow_up}</span>}
				</div>
			</div>
			<div className={`col-lg-6 ${
				role === 4  ? 'admin-flatpicker' : 'flatpicker'
			}`}>
			{data && data.follow_up==="true" && <div className=" form-group">
				<label>{t('modal.when')} </label>
					{/* <input type="date" min={new Date().toISOString().split('T')[0]} name="follow_up_date" onChange={handleChange} value={data.follow_up_date?data.follow_up_date:''} className={`form-control ${role === 4 ? 'admin-date-input' : ''}`} placeholder=" Date "/> */}
					<div className="input-group">
					<Flatpickr
					value={data.follow_up_date || ""}
					name="follow_up_date"
					onChange={(selectedDates) => {
						const selectedDate = selectedDates[0]; // Get the selected date
						if (selectedDate) {
						// Format the date as 'YYYY-MM-DD'
						const formattedDate = flatPickerFormatDate(selectedDate);
							handleChange({
								target: {
									name: "follow_up_date",
									value: formattedDate, // Format as YYYY-MM-DD
								},
							});
						}
					}}
					options={{
						dateFormat: "Y-m-d", // Format of the date
						minDate: "today", // Minimum date as today
						appendTo: document.body, // Ensure dropdown attaches to body
					}}
					placeholder={t('profile.selectDate')}
					className="form-control" // Optional: Add a CSS class
					ref={followflatpickrRef} // Bind Flatpickr to the ref
					/>
					{/* Calendar Icon */}
					<span className="input-group-text input-button" title="toggle"
					onClick={() => followflatpickrRef.current.flatpickr.open()}>
						<i className="ri-calendar-line"></i>
					</span>
				</div>
				{error && error.follow_up_date && <span className="required">{error.follow_up_date}</span>}
				</div>}
			</div>
		</div>
		{/*Footer Section*/}
		<Modal.Footer>
	   <Button variant="secondary" className={`btn btn-sm ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmPink'}`} onClick={props.handleClose}>
          {t('modal.close')}
        </Button>
		<Button type="submit" variant="secondary" onClick={handleSubmit} className={`btn btn-sm ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue'}`}>
          {t('profile.submit')}
        </Button>
	  </Modal.Footer>
	</form>
	{/*End DiagnosisAdd Form*/}
	</Modal.Body>
	</Modal>
  );
}

export default DiagnosisAddModal;
